import { render, staticRenderFns } from "./vCardSolution.vue?vue&type=template&id=18b2daec&"
import script from "./vCardSolution.vue?vue&type=script&lang=js&"
export * from "./vCardSolution.vue?vue&type=script&lang=js&"
import style0 from "./vCardSolution.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports